import styled from "@emotion/styled";

export const Container = styled.div`
  display: flex;
  min-width: 480px;
  padding: 20px;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  align-self: stretch;

  border-radius: 16px;
  border: 1px solid var(--alias-color-line-normal, #e4e5e7);
  background: var(--alias-color-background-normal-normal, #fff);
`;

export const TopSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
`;

export const HistorySection = styled.div`
  display: flex;
  height: 80px;
  padding: 12px;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  overflow-y: auto;
  overflow: auto;

  border-radius: 12px;
  border: 1px solid var(--alias-color-line-strong);
  background: var(--alias-color-background-normal-alternative);
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  align-self: stretch;
`;

export const SettingContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  align-self: stretch;
`;

export const CapacityContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  flex: 1 0 0;
`;

export const LabelContainer = styled.div`
  display: flex;
  gap: 3px;
  align-items: center;
`;
